import moment from 'moment';

export const CONVERSION_STATE = {
  NONE: 'NONE',
  IN_PROGRESS: 'IN_PROGRESS',
  BLOCKED: 'BLOCKED',
  CONVERTED: 'CONVERTED',
};

export const BLOCKED_REASON = {
  PRIOR_FAILED_CHECK: 'PRIOR_FAILED_CHECK',
  FAILED_CHECK_DURING_CONVERSION: 'FAILED_CHECK_DURING_CONVERSION',
};

export const IN_PROGRESS_STAGES = {
  AWAITING_PROFILE: 'In progress - awaiting profile completion',
  BGC_PENDING: 'In progress - background check pending',
  AWAITING_ROUTE_CLOSEOUT: 'In progress - awaiting route close-out',
};

const ENABLED_STATE = { hidden: false, disabled: false, tooltip: '' };
const DISABLED_STATE = { hidden: false, disabled: true, tooltip: '' };

/**
 * Decides how the Convert button looks for a driver's `conversion` info.
 */
export const getConvertButtonState = (conversion, now = new Date()) => {
  const {
    state,
    stage,
    blocked_reason: blockedReason,
    blocked_until: blockedUntil,
    lastMessage = '',
  } = conversion || {};

  switch (state) {
    case CONVERSION_STATE.CONVERTED:
      return { hidden: true, disabled: true, tooltip: '' };
    case CONVERSION_STATE.IN_PROGRESS:
      return { ...DISABLED_STATE, tooltip: lastMessage || IN_PROGRESS_STAGES[stage] || 'In progress' };
    case CONVERSION_STATE.BLOCKED: {
      // BE keeps returning BLOCKED after the block lifts but accept to submit convert driver,
      // so a passed blocked_until re-enables the button
      if (blockedUntil && !moment(blockedUntil).isAfter(now)) {
        return ENABLED_STATE;
      }
      let tooltip = 'Conversion failed due to failed BGC';
      if (blockedReason === BLOCKED_REASON.FAILED_CHECK_DURING_CONVERSION && blockedUntil) {
        tooltip = `BGC Failed - cannot convert until ${moment(blockedUntil).format('YYYY-MM-DD')}`;
      }
      return { ...DISABLED_STATE, tooltip };
    }
    default:
      return ENABLED_STATE;
  }
};
